import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, CheckCircle } from 'lucide-react';

const DashboardProfileAlert = ({ provider, setActiveTab }) => {
  return (
    <>
      {provider.profile_completeness && !provider.profile_completeness.is_complete && (
        <div className="bg-gradient-to-r from-orange-50 to-yellow-50 border border-orange-200 rounded-2xl p-6 mb-6" data-testid="profile-completeness-alert">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center shrink-0">
              <Shield className="w-6 h-6 text-orange-600" />
            </div>
            <div className="flex-1">
              <h3 className="font-bold text-lg text-gray-900 mb-1">Completa tu perfil para aparecer más arriba</h3>
              <p className="text-sm text-gray-600 mb-4">
                Tu perfil está al {provider.profile_completeness.percentage}% completo.
                Los perfiles completos tienen más visibilidad en las búsquedas.
              </p>

              <div className="w-full bg-gray-200 rounded-full h-2.5 mb-4">
                <div
                  className="bg-gradient-to-r from-orange-500 to-green-500 h-2.5 rounded-full transition-all duration-500"
                  style={{ width: `${provider.profile_completeness.percentage}%` }}
                ></div>
              </div>

              <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
                {Object.entries(provider.profile_completeness.sections).map(([key, section]) => (
                  <Link
                    key={key}
                    to={key === 'services' ? '/provider/dashboard' : '/provider/account'}
                    onClick={() => {
                      if (key === 'services') setActiveTab('services');
                    }}
                    className={`flex items-center gap-2 p-3 rounded-xl transition-colors ${
                      section.complete
                        ? 'bg-green-100 text-green-800'
                        : 'bg-white border border-orange-200 text-gray-700 hover:border-orange-400 hover:bg-orange-50'
                    }`}
                  >
                    {section.complete ? (
                      <CheckCircle className="w-5 h-5 text-green-600 shrink-0" />
                    ) : (
                      <div className="w-5 h-5 border-2 border-orange-400 rounded-full shrink-0" />
                    )}
                    <span className="text-sm font-medium">{section.name}</span>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      {provider.profile_completeness?.is_complete && (
        <div className="bg-green-50 border border-green-200 rounded-xl p-4 mb-6 flex items-center gap-3" data-testid="profile-complete-badge">
          <CheckCircle className="w-6 h-6 text-green-600" />
          <div>
            <p className="font-medium text-green-800">¡Tu perfil está completo!</p>
            <p className="text-sm text-green-600">Los clientes pueden encontrarte en las búsquedas.</p>
          </div>
        </div>
      )}
    </>
  );
};

export default DashboardProfileAlert;
